import { licensePlateCountries } from '../data/countries.data';
import { LicensePlateCountry, LPRCountryCode } from '../models/country';

export function formatLicensePlate(licensePlate: string, countryCode?: LPRCountryCode): string {
  let formattedLicensePlate = licensePlate.split(':').join('-');
  if (countryCode) {
    formattedLicensePlate += ` [${countryCode}]`;
  }
  return formattedLicensePlate;
}

//prettier-ignore
const _at_first_box = ["A", "AM", "B", "BA", "BB", "BD", "BG", "BH", "BK", "BL", "BM", "BN", "BP", "BR", "BZ", "CC", "CD", "DL", "DO", "E", "EF", "EU", "FB", "FE", "FF", "FK", "FR", "FV", "FW", "G", "GB", "GD", "GF", "GK", "GM", "GR", "GS", "GU", "HA", "HB", "HE", "HF", "HL", "HO", "I", "IL", "IM", "JE", "JO", "JU", "JW", "K", "KB", "KD", "KF", "KG", "KI", "KK", "KL", "KO", "KR", "KS", "KU", "L", "LA", "LB", "LD", "LE", "LF", "LI", "LK", "LL", "LN", "LZ", "MA", "MD", "ME", "MI", "MT", "MU", "MZ", "N", "ND", "NK", "O", "OP", "OW", "P", "PE", "PL", "PT", "RA", "RE", "RI", "RO", "S", "SB", "SD", "SE", "SK", "SL", "SO", "SP", "SR", "ST", "SV", "SW", "SZ", "T", "TA", "TD", "TK", "TU", "UU", "V", "VB", "VD", "VI", "VK", "VL", "VO", "W", "WB", "WD", "WE", "WK", "WL", "WN", "WO", "WT", "WU", "WY", "WZ", "ZE", "ZT", "ZW"];
//prettier-ignore
const _at_first_box_2nd_box_only_digits = ["A", "N", "O", "ST", "T", "V", "WD", "WK", "BD", "BH", "BP", "FV", "JW", "PT"];
//prettier-ignore
const _de_first_box = ["A", "AA", "AB", "ABG", "ABI", "AC", "AE", "AG", "AH", "AIB", "AIC", "AK", "AL", "ALF", "ALS", "ALZ", "AM", "AN", "ANA", "ANG", "ANK", "AP", "APD", "AR", "ARN", "ART", "AS", "ASD", "ASL", "ASZ", "AT", "AU", "AUR", "AW", "AZ", "AZE", "AÖ", "B", "BA", "BAD", "BAR", "BB", "BBG", "BBL", "BC", "BCH", "BD", "BE", "BED", "BEI", "BEL", "BER", "BF", "BG", "BGD", "BGL", "BH", "BI", "BID", "BIN", "BIR", "BIT", "BIW", "BK", "BKS", "BL", "BLB", "BLK", "BM", "BN", "BNA", "BO", "BOG", "BOH", "BOR", "BOT", "BP", "BR", "BRA", "BRB", "BRG", "BRI", "BRK", "BRL", "BRV", "BS", "BSB", "BSK", "BT", "BTF", "BU", "BUL", "BW", "BWL", "BYL", "BZ", "BZA", "BÖ", "BÜD", "BÜR", "BÜS", "BÜZ", "C", "CA", "CAS", "CB", "CE", "CHA", "CLP", "CLZ", "CO", "COC", "COE", "CR", "CUX", "CW", "D", "DA", "DAH", "DAN", "DAU", "DB", "DBR", "DD", "DE", "DEG", "DEL", "DGF", "DH", "DI", "DIL", "DIN", "DIZ", "DKB", "DL", "DLG", "DM", "DN", "DO", "DON", "DS", "DT", "DU", "DUD", "DW", "DZ", "DÜW", "E", "EA", "EB", "EBE", "EBN", "EBS", "ECK", "ED", "EE", "EF", "EG", "EH", "EHI", "EI", "EIC", "EIH", "EIL", "EIN", "EIS", "EL", "EM", "EMD", "EMS", "EN", "ER", "ERB", "ERH", "ERK", "ERZ", "ES", "ESA", "ESB", "ESW", "EU", "EUT", "EW", "F", "FAL", "FB", "FD", "FDB", "FDS", "FEU", "FF", "FFB", "FG", "FH", "FI", "FKB", "FL", "FLÖ", "FN", "FO", "FOR", "FR", "FRG", "FRI", "FRW", "FS", "FT", "FTL", "FW", "FZ", "FÜ", "FÜS", "G", "GA", "GAN", "GAP", "GC", "GD", "GDB", "GE", "GEL", "GEM", "GEO", "GER", "GF", "GG", "GHA", "GHC", "GI", "GK", "GL", "GLA", "GM", "GMN", "GN", "GNT", "GOA", "GOH", "GP", "GR", "GRA", "GRH", "GRI", "GRM", "GRS", "GRZ", "GS", "GT", "GTH", "GUB", "GUN", "GV", "GVM", "GW", "GZ", "GÖ", "GÜ", "H", "HA", "HAB", "HAL", "HAM", "HAS", "HB", "HBN", "HBS", "HC", "HCH", "HD", "HDH", "HDL", "HE", "HEB", "HEF", "HEI", "HEL", "HER", "HET", "HF", "HG", "HGN", "HGW", "HH", "HHM", "HI", "HIG", "HIP", "HK", "HL", "HM", "HMÜ", "HN", "HO", "HOG", "HOH", "HOL", "HOM", "HOR", "HOT", "HP", "HR", "HRO", "HS", "HSK", "HST", "HU", "HUS", "HV", "HVL", "HW", "HWI", "HX", "HY", "HZ", "HÖS", "HÜN", "IGB", "IK", "IL", "ILL", "IN", "IS", "IZ", "J", "JB", "JE", "JEV", "JL", "JÜL", "K", "KA", "KAR", "KB", "KC", "KE", "KEH", "KEL", "KEM", "KF", "KG", "KH", "KI", "KIB", "KK", "KL", "KLE", "KLZ", "KM", "KN", "KO", "KR", "KRU", "KS", "KT", "KU", "KUS", "KW", "KY", "KYF", "KÖN", "KÖT", "KÖZ", "KÜN", "L", "LA", "LAN", "LAT", "LAU", "LB", "LBS", "LBZ", "LC", "LD", "LDK", "LDS", "LE", "LEO", "LER", "LEV", "LF", "LG", "LH", "LI", "LIB", "LIF", "LIN", "LIP", "LK", "LL", "LM", "LN", "LOH", "LOS", "LP", "LR", "LRO", "LS", "LSA", "LSN", "LSZ", "LU", "LUK", "LUP", "LWL", "LÖ", "LÖB", "LÜD", "LÜN", "M", "MA", "MAB", "MAI", "MAK", "MAL", "MAR", "MB", "MC", "MD", "ME", "MED", "MEG", "MEI", "MEK", "MEL", "MEP", "MER", "MES", "MET", "MG", "MGH", "MGN", "MH", "MHL", "MI", "MIL", "MK", "MKK", "ML", "MM", "MN", "MO", "MOD", "MOL", "MON", "MOS", "MQ", "MR", "MS", "MSE", "MSH", "MSP", "MST", "MT", "MTK", "MTL", "MVL", "MW", "MY", "MYK", "MZ", "MZG", "MÜ", "MÜB", "MÜL", "MÜN", "MÜR", "N", "NAB", "NAI", "NAU", "NB", "ND", "NDH", "NE", "NEA", "NEB", "NEC", "NEN", "NES", "NEU", "NEW", "NF", "NH", "NI", "NIB", "NK", "NL", "NM", "NMB", "NMS", "NOH", "NOL", "NOM", "NOR", "NP", "NR", "NRW", "NRÜ", "NT", "NU", "NVP", "NW", "NWM", "NY", "NZ", "NÖ", "OA", "OAL", "OB", "OBB", "OBG", "OC", "OCH", "OD", "OE", "OF", "OG", "OH", "OHA", "OHV", "OHZ", "OK", "OL", "OLD", "OP", "OPR", "OR", "OS", "OSL", "OTT", "OTW", "OVI", "OVL", "OVP", "OZ", "P", "PA", "PAF", "PAN", "PAR", "PB", "PCH", "PE", "PEG", "PER", "PF", "PI", "PIR", "PK", "PL", "PLÖ", "PM", "PN", "PR", "PRÜ", "PS", "PW", "PZ", "QFT", "QLB", "R", "RA", "RC", "RD", "RDG", "RE", "REG", "REH", "REI", "RG", "RH", "RI", "RID", "RIE", "RL", "RM", "RN", "RO", "ROD", "ROF", "ROH", "ROK", "ROL", "ROS", "ROT", "ROW", "RP", "RPL", "RS", "RSL", "RT", "RU", "RV", "RW", "RWL", "RY", "RZ", "RÜD", "RÜG", "S", "SAB", "SAD", "SAL", "SAN", "SAW", "SB", "SBG", "SBK", "SC", "SCZ", "SDH", "SDL", "SDT", "SE", "SEB", "SEE", "SEF", "SEL", "SF", "SFA", "SFB", "SFT", "SG", "SGH", "SH", "SHA", "SHG", "SHK", "SHL", "SI", "SIG", "SIM", "SK", "SL", "SLE", "SLF", "SLG", "SLK", "SLN", "SLS", "SLZ", "SLÜ", "SM", "SMÜ", "SN", "SNH", "SO", "SOB", "SOG", "SOK", "SOL", "SON", "SP", "SPB", "SPN", "SPR", "SR", "SRB", "SRO", "ST", "STA", "STB", "STD", "STE", "STH", "STL", "STO", "SU", "SUL", "SW", "SWA", "SY", "SZ", "SZB", "SÄK", "SÖM", "SÜW", "TBB", "TDO", "TE", "TET", "TF", "TG", "THL", "THW", "TIR", "TO", "TP", "TR", "TS", "TT", "TUT", "TÖL", "TÖN", "TÜ", "UE", "UEM", "UER", "UFF", "UH", "UL", "UM", "UN", "USI", "V", "VAI", "VB", "VEC", "VER", "VG", "VIB", "VIE", "VIT", "VK", "VL", "VOF", "VOH", "VR", "VS", "W", "WA", "WAF", "WAK", "WAN", "WAR", "WAT", "WB", "WBS", "WD", "WDA", "WE", "WEB", "WEG", "WEL", "WEM", "WEN", "WER", "WES", "WF", "WG", "WHV", "WI", "WIL", "WIS", "WIT", "WIZ", "WK", "WL", "WLG", "WM", "WMS", "WN", "WND", "WO", "WOB", "WOH", "WOL", "WOR", "WOS", "WR", "WRN", "WS", "WSF", "WST", "WSW", "WT", "WTL", "WTM", "WUG", "WUN", "WUR", "WW", "WZ", "WZL", "WÜ", "WÜM", "X", "Y", "Z", "ZE", "ZEL", "ZI", "ZIG", "ZP", "ZR", "ZS", "ZW", "ZZ", "ÖHR", "ÜB",];
//prettier-ignore
const _ch_first_box = ["AG", "AI", "AR", "BE", "BL", "BS", "FR", "GE", "GL", "GR", "JU", "LU", "M", "NE", "NW", "OW", "SG", "SH", "SO", "SZ", "TG", "TI", "UR", "VD", "VS", "ZG", "ZH",];

export function getCountryByLPRCode(lprCode: LPRCountryCode): LicensePlateCountry {
  return (
    licensePlateCountries.find((country) => country.lprCode === lprCode) ??
    licensePlateCountries.find((country) => country.lprCode === 'UNKNOWN')!
  );
}

//Returns true if the license plate is valid, false otherwise
export function checkLicensePlateFormat(licensePlate: string, countryCode: LPRCountryCode): boolean {
  if (!licensePlate || !countryCode) return false;
  const fullCountry = getCountryByLPRCode(countryCode);

  if (fullCountry.firstPartLength) {
    if (countryCode === 'A') return validateLicensePlateAT(licensePlate);
    if (countryCode === 'D') return validateLicensePlateDE(licensePlate);
    if (countryCode === 'CH') return validateLicensePlateCH(licensePlate);

    const parts = licensePlate.split(':');
    return parts.length === 2 && parts[0].length <= fullCountry.firstPartLength && parts[0].length > 0 && parts[1].length > 0;
  } else {
    if (!licensePlate.includes(':')) {
      return countryCode === 'I' ? validateLicensePlateIT(licensePlate) : true;
    }
    return false;
  }
}

export function validateLicensePlateBasic(licensePlate: string, countryCode: LPRCountryCode): boolean {
  if (!licensePlate || !countryCode) return false;

  // Check if the country code exists in our country code list
  const fullCountry = getCountryByLPRCode(countryCode);
  if (!fullCountry) return false;

  // Check if the license plate only consists of numbers, letters, äöü and a maximum of 1 colon
  const validCharacters = /^[A-Z0-9ÄÖÜ:]+$/i;
  if (!validCharacters.test(licensePlate)) return false;

  const parts = licensePlate.split(':');
  if (fullCountry.firstPartLength) {
    return parts.length === 2 && parts[0].length <= fullCountry.firstPartLength;
  } else return parts.length === 1;
}

function validateLicensePlateAT(licensePlate: string): boolean {
  let [firstBox, secondBox] = licensePlate.split(':');

  // wirkt so als wär die maximallänge in österreich 7
  if (licensePlate.replace(/[^ÄÖÜA-Z0-9]/g, '').length > 7) {
    return false;
  }

  // 1 Box: Erlaubte Werte in erster Box: A.txt
  if (!_at_first_box.includes(firstBox)) {
    return false;
  }

  // 2 Box:
  // "0" darf nie die erste Ziffer im Kennzeichen sein. Beginnt eine 2. Box mit "0", müsste das ein "O" sein
  if (secondBox.startsWith('0')) {
    return false;
  }

  if (_at_first_box_2nd_box_only_digits.includes(firstBox)) {
    // Wert in 1. Box in ["A", "N", "O", "ST", "T", "V", "WD", "WK", "BD", "BH", "BP", "FV", "JW", "PT"]
    return /^\d+$/.test(secondBox);
  }

  // Sonst: mindestens eine Ziffer und ein Buchstabe
  let firstDigit = secondBox.search(/\d/);
  let firstLetter = secondBox.search(/[A-Z]/);
  if ((firstDigit === -1 || firstLetter === -1) && firstBox != 'W') {
    return false;
  }

  // 2 Box beginnt mit Buchstaben: Nur Buchstaben erlaubt bis zur ersten Ziffer. Ab der ersten Ziffer nur mehr Ziffern erlaubt. z.B K EWYN 1
  let startsWithDigit = /^\d/.test(secondBox);
  if (!startsWithDigit && !/^[A-Z]+\d+$/.test(secondBox)) {
    return false;
  }

  // 2 Box beginnt mit Ziffer: Nur Ziffern erlaub bis zu erstem Buchstaben. Ab erstem Buchstaben nur mehr Buchstaben erlaubt.
  // Achtung, hier kann immer noch 0/O verwechselt werden, weil G 12OAB und G 120AB möglich
  if (startsWithDigit && !/^\d+[A-Z]*$/.test(secondBox)) {
    return false;
  }

  if (firstBox == 'W' && startsWithDigit && /^\d+[A-Z]{4,}$/.test(secondBox)) {
    return false;
  }

  return true;
}

function validateLicensePlateDE(licensePlate: string): boolean {
  let [firstBox, secondBox] = licensePlate.split(':');

  // 1 Box: Erlaubte Werte in erster Box: D.txt
  if (!_de_first_box.includes(firstBox)) {
    return false;
  }

  // 2. Box min length 2
  if (!secondBox || secondBox.length < 2) {
    return false;
  }

  // in deutschland kann das kennzeichen maximal 8 haben
  if (`${firstBox}${secondBox.replace(/[^ÄÖÜA-Z0-9]/g, '')}`.length > 8) {
    return false;
  }

  // 2. Box
  // in der 2. Box sind keine Umlaute (ÄÖÜ) erlaubt
  if (/[ÄÖÜ]/.test(secondBox)) {
    return false;
  }

  // Box beginnt mit Ziffer: Es dürfen nur Ziffern folgen: z.B. BP 2795
  if (/^\d/.test(secondBox)) {
    return /^\d+$/.test(secondBox);
  }

  // Box beginnt mit Buchstaben: z.B. PA MQ 91, PB M 954
  if (/^[A-Z]/.test(secondBox)) {
    // Zuerst 1 oder 2 Buchstaben
    // dann 1 bis 4 Ziffern
    // eventuell am Ende noch "H" (das ist offizieller Teil des Kennzeichens) oder "E" (das geben viele nicht ein, weil es offiziell nicht Teil des Kennzeichens ist), z.B. PA MQ 91H, PB M 954E
    if (!/^[A-Z]{1,2}\d{1,4}[HE]?$/.test(secondBox)) {
      return false;
    }
  }

  return true;
}

function validateLicensePlateCH(licensePlate: string) {
  let [firstBox, secondBox] = licensePlate.split(':');

  // zweite box maximal 6 haben
  if (secondBox.replace(/[^ÄÖÜA-Z0-9]/g, '').length > 6) {
    return false;
  }

  // 1 Box: Erlaubte Werte in erster Box: CH.txt
  if (!_ch_first_box.includes(firstBox)) {
    return false;
  }

  // Box: Nur Ziffern erlaubt, Ausnahmen
  // Nachgestelltes "U" (z.B. GR 67 U) oder "Z" (LU 9 Z)
  if (!/^\d+[UZ]?$/.test(secondBox)) {
    return false;
  }

  return true;
}

function validateLicensePlateIT(licensePlate: string) {
  // Schema fix AB123CD (2 Buchstaben, 3 Ziffern, 2 Buchstaben): außer einzelne Sonderkennzeichen
  if (!/^[A-Z]{2}\d{3}[A-Z]{2}$/.test(licensePlate)) {
    return false;
  }

  // erlaubte buchstaben: ABCDEFGHJKLMNPRSTVWXYZ
  if (!/^[ABCDEFGHJKLMNPRSTVWXYZ0-9]+$/.test(licensePlate)) {
    return false;
  }

  return true;
}
